'use client'

import { useState } from 'react'
import AuthShell from '@/components/AuthShell'
import { confirmPasswordReset, requestPasswordReset } from '@/lib/auth/cognito'

export default function JaResetPasswordPage() {
  const [email, setEmail] = useState('')
  const [code, setCode] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [step, setStep] = useState<'request' | 'confirm'>('request')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')

  const requestReset = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setSuccess('')
    try {
      setIsSubmitting(true)
      await requestPasswordReset(email)
      setStep('confirm')
      setSuccess('確認コードを送信しました。メールをご確認ください。')
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'リセットコードの送信に失敗しました。')
    } finally {
      setIsSubmitting(false)
    }
  }

  const confirmReset = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setSuccess('')
    try {
      setIsSubmitting(true)
      await confirmPasswordReset(email, code, newPassword)
      setSuccess('パスワードを更新しました。ログインしてください。')
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'パスワード再設定に失敗しました。')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <AuthShell
      title="パスワード再設定"
      subtitle="コードを受け取ってから新しいパスワードを設定してください。"
      footerText="パスワードを思い出しましたか？"
      footerLinkHref="/ja/login"
      footerLinkLabel="ログインに戻る"
    >
      {step === 'request' ? (
        <form onSubmit={requestReset} className="space-y-5">
          <div>
            <label htmlFor="email" className="block text-sm font-semibold text-brand-charcoal mb-1">メールアドレス</label>
            <input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-4 py-3 border border-brand-cool-gray rounded-lg focus:ring-2 focus:ring-brand-green outline-none" />
          </div>
          {error ? <p className="text-sm text-brand-red">{error}</p> : null}
          {success ? <p className="text-sm text-brand-green">{success}</p> : null}
          <button type="submit" disabled={isSubmitting} className="w-full py-3 rounded-lg font-semibold text-white bg-brand-green hover:bg-brand-green-deep disabled:bg-brand-muted">
            {isSubmitting ? '送信中...' : 'リセットコードを送信'}
          </button>
        </form>
      ) : (
        <form onSubmit={confirmReset} className="space-y-5">
          <div>
            <label htmlFor="code" className="block text-sm font-semibold text-brand-charcoal mb-1">確認コード</label>
            <input id="code" type="text" required value={code} onChange={(e) => setCode(e.target.value)} className="w-full px-4 py-3 border border-brand-cool-gray rounded-lg focus:ring-2 focus:ring-brand-green outline-none" />
          </div>
          <div>
            <label htmlFor="newPassword" className="block text-sm font-semibold text-brand-charcoal mb-1">新しいパスワード</label>
            <input id="newPassword" type="password" minLength={8} required value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className="w-full px-4 py-3 border border-brand-cool-gray rounded-lg focus:ring-2 focus:ring-brand-green outline-none" />
          </div>
          {error ? <p className="text-sm text-brand-red">{error}</p> : null}
          {success ? <p className="text-sm text-brand-green">{success}</p> : null}
          <button type="submit" disabled={isSubmitting} className="w-full py-3 rounded-lg font-semibold text-white bg-brand-green hover:bg-brand-green-deep disabled:bg-brand-muted">
            {isSubmitting ? '更新中...' : 'パスワードを更新'}
          </button>
        </form>
      )}
    </AuthShell>
  )
}
